import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "space-y-6" }
const _hoisted_2 = { class: "mt-8 md:mt-4" }
const _hoisted_3 = { class: "text-4xl font-medium capitalize" }
const _hoisted_4 = { class: "mt-8 md:mt-4" }
const _hoisted_5 = { class: "text-3xl font-medium capitalize" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "text-2xl font-medium capitalize" }
const _hoisted_8 = { class: "text-2xl" }
const _hoisted_9 = {
  key: 1,
  class: "mt-6"
}
const _hoisted_10 = { class: "text-2xl font-medium capitalize" }
const _hoisted_11 = { class: "text-2xl" }
const _hoisted_12 = {
  key: 0,
  class: "mt-6"
}

import { ref } from "vue";
  import { useRoute } from "vue-router";

  import TitleHeader from "@/components/TitleHeader.vue";
  import RouterButton from "@/components/RouterButton.vue";

  import api from "@/api/api";
  import { useGlobalStore } from "@/store";
  import { Event, SurveyResponse } from "@/types";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'SurveyResponse',
  async setup(__props) {

let __temp: any, __restore: any

  const route = useRoute();
  const globalStore = useGlobalStore();

  const response = ref([] as SurveyResponse);
  const event = ref({} as Event);
  const newUser = ref();
  const eventID = route.params.id;
  const userID = route.params.user_id;

  try {
    event.value = ((
  ([__temp,__restore] = _withAsyncContext(() => api.events.getEvent(String(eventID)))),
  __temp = await __temp,
  __restore(),
  __temp
)).data.event;
    const res = (
  ([__temp,__restore] = _withAsyncContext(() => api.surveys.getUserSurveyResponse(eventID, userID))),
  __temp = await __temp,
  __restore(),
  __temp
);
    newUser.value = res.data.user ? res.data.user.name : res.data.name;
    response.value = res.data.surveyResults;

  } catch (error) {
    globalStore.toast("ERROR", "Error loading Survey data");
    window.location.href = "/error";
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(RouterButton, {
        type: "primary",
        to: { path: `/dashboard/training-feedback/${_unref(eventID)}` }
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("back-to")) + " " + _toDisplayString(_ctx.$t("course-feedback")), 1)
        ]),
        _: 1
      }, 8, ["to"]),
      _createVNode(TitleHeader, {
        title: event.value?.name
      }, null, 8, ["title"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(newUser.value) + " : " + _toDisplayString(_ctx.$t("response")), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(response.value, (question, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "mt-4 md:mt-4",
          key: question.id
        }, [
          _createElementVNode("p", _hoisted_5, _toDisplayString(`Q${index + 1}.`) + " " + _toDisplayString(question.question_text), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.answers, (answer) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "mt-6",
              key: answer.id
            }, [
              (answer.answer_text)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("answer")), 1),
                    _createElementVNode("span", _hoisted_8, " : " + _toDisplayString(answer.answer_text), 1)
                  ]))
                : _createCommentVNode("", true),
              (answer.answer_comment)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t("comment")), 1),
                    _createElementVNode("span", _hoisted_11, " : " + _toDisplayString(answer.answer_comment), 1)
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128)),
          (index + 1 !== response.value.length)
            ? (_openBlock(), _createElementBlock("hr", _hoisted_12))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ])
  ], 64))
}
}

})